import { type Content, isAttachmentAttachmentMetaInfo } from '@generalTypes/apiTypes';
import { selectContentItem } from '@newStore/documentApi/documentApiSelectors';
import { createTypedSelector } from '@newStore/genericHelpers';
import { NodeType } from '@nodeTypeConfig/configTypes';
import { compactTitle } from '@store/helpers/documentHelpers';
import { settings } from '../../../config/settings';
import type { MusicNode } from '../documentUITypes';

export const selectMusicNode = createTypedSelector(
  [(state, href) => selectContentItem(state, href)],
  (content: Content): MusicNode => {
    const attachment = content.attachments.find(isAttachmentAttachmentMetaInfo);
    return {
      key: content.key,
      title: compactTitle(attachment?.name),
      href: content.$$meta.permalink,
      mp3src: attachment?.href && settings.apisAndUrls.contentApi + attachment.href,
      type: NodeType.MUSIC,
      customRender: true,
    };
  },
);
